import { render, staticRenderFns } from "./LoginPwd.vue?vue&type=template&id=54344081&scoped=true&"
import script from "./LoginPwd.vue?vue&type=script&lang=js&"
export * from "./LoginPwd.vue?vue&type=script&lang=js&"
import style0 from "./LoginPwd.vue?vue&type=style&index=0&id=54344081&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54344081",
  null
  
)

export default component.exports